<h2>This is not a full application, just a simple version for demonstration purposes.</h2>
